var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightDatepickerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9996,
    cy: 12.998,
    r: 12,
    fill: "#031434"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3953_20621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 9.99805L10.2947 10.703L12.5847 12.998L10.2947 15.293L10.9997 15.998L13.9997 12.998L10.9997 9.99805Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3953_20621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(5.99963 6.99805)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightDatepickerIcon);
export default __webpack_public_path__ + "static/media/arrow_right_datepicker_icon.b3c11af3d506eb6b6cc76bd1bebaffbf.svg";
export { ForwardRef as ReactComponent };